import React, { Suspense } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Files from './files'

const App = () => {
  return (
    <>
      <BrowserRouter>
        <Suspense fallback={<div>Loading...</div>}>
          <Routes>
            {Files.map((file) => {
              const Component = file.component
              return (
                <Route
                  path={file.path}
                  key={file.path}
                  element={<Component />}
                />
              )
            })}
          </Routes>
        </Suspense>
      </BrowserRouter>
    </>
  )
}

export default App
